import {
    Component,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
} from '@angular/core';
// import { FirebaseSna } from 'angularfire2';

import { AuthService } from '../auth/guard.service';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first';

import { TagService, Tag } from '../tags/tag.service';

import { Item, IndexedSnap, SelectRequestDir, SelectRequest} from './Item.component';

import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';

export interface IndexedRef {
    dateStr : string,
    select : Observable<void>,
    ref : firebase.database.Reference, // firebase reference
}

@Component({
    selector: 'new-item',
    templateUrl: './NewItem.component.html',
    styleUrls: ['./Item.component.sass', './NewItem.component.css']
})
export class NewItemComponent implements OnInit, OnChanges, OnDestroy {

    @Input() public ref : IndexedRef
    private selectionSub : Subscription
    @Output() selectRequest = new EventEmitter<SelectRequestDir>();

    @ViewChild('itemInput') input : ElementRef;

    constructor(private tagService : TagService) {}

    contentChanged(newValue : string) {
        let val = newValue.trim();
        if (val.length > 0) {
            this.save();
        }
        this.input.nativeElement.innerText = "";
    }

    save() {
        let text = this.input.nativeElement.innerText.trim();

        let tags = this.tagService.parse(text);
        for (let tag of tags) {
            this.tagService.createTagIfNotExists({
                display: tag.display,
                normalised: tag.normalised,
                description: "",
                colour: "#FF0000",
            });
        }

        let tagMap = {};
        for (let tag of tags) {
            tagMap[tag.normalised] = true;
        }

        // timestamp like Swift likes it
        let timestamp = new Date().getTime() / 1000.0;
        this.ref.ref.push({
            text: text,
            date: this.ref.dateStr,
            timestamp: timestamp,
            tags: tagMap,
        });
    }

    onKeyDown(e : KeyboardEvent) {
        if (e.keyCode == 13) {
            // Enter key
            e.preventDefault();
            this.contentChanged(this.input.nativeElement.innerText);
        } else if (e.keyCode == 9) {
            // Tab key
            e.preventDefault();
            if (e.shiftKey) {
                this.selectRequest.emit(SelectRequestDir.Previous);
            } else {
                this.contentChanged(this.input.nativeElement.innerText);
            }
        } else if (e.keyCode == 27){
            // Escape key
            e.preventDefault();

            // cancel the input
            this.input.nativeElement.innerText = "";

            // deselect
            this.blur();
        }
    }

    blur() {
        // blur (deselect) the item
        this.input.nativeElement.blur();
        window.getSelection().removeAllRanges();
    }

    ngOnInit() {
    }

    // thanks http://stackoverflow.com/a/4238971/555516
    placeCaretAtEnd() {
        let el = this.input.nativeElement;
        el.focus();
        if (typeof window.getSelection != "undefined"
                && typeof document.createRange != "undefined") {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof (document.body as any).createTextRange != "undefined") {
            var textRange = (document.body as any).createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }


    ngOnChanges() {
        // this.text = this.item.snap.val().text.trim();
        this.selectionSub = this.ref.select.subscribe(() => {
            // select the article
            this.placeCaretAtEnd();
        })
    }

    ngOnDestroy() {

    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/items/NewItem.component.ts